import { FetchModels, ViewsModels } from '../types';

const AXIS_AS_IMAGE_THUMB_CRITERIA = 'цвет';

export const processFetchedResult =
  (productId: string) =>
  (data: FetchModels.VariantsEntity | null): ViewsModels.VariantsModel => {
    let variantsModel: ViewsModels.VariantsAxisModel[] = [];
    let activePoint: ViewsModels.Product | undefined;

    if (data) {
      const { products = [], axisList = [] } = data;
      activePoint = products.find((p) => p.productId === productId);
      if (activePoint) {
        variantsModel = getVariantsModel(activePoint, axisList, products);
      }
    }

    return {
      variantsModel,
      activePoint,
    };
  };

const getAxisValue = (axisId: string, axisValues: ViewsModels.AxisValue[]): string =>
  axisValues.find((av: ViewsModels.AxisValue) => av.id === axisId)?.axis || '';

const getVariantsModel = (
  activePoint: ViewsModels.Product,
  axisList: ViewsModels.VariantsAxis[],
  products: ViewsModels.Product[],
): ViewsModels.VariantsAxisModel[] =>
  axisList.map((axisMeta) => {
    const pointsOnAxis = getProductsOnAxis(activePoint, products, axisMeta, axisList);

    // Reference to:
    // - https://confluence.lmru.tech/pages/viewpage.action?pageId=139765243
    // - https://jira.lmru.tech/browse/MF-2274
    const asImageThumb = axisMeta.name.toLowerCase() === AXIS_AS_IMAGE_THUMB_CRITERIA;
    return {
      axisMeta,
      pointsOnAxis,
      asImageThumb,
    };
  });

const getProductsOnAxis = (
  activePoint: ViewsModels.Product,
  products: ViewsModels.Product[],
  axisMeta: ViewsModels.VariantsAxis,
  axisList: ViewsModels.VariantsAxis[],
) => {
  const { attribute: currentAxisId } = axisMeta;
  const otherAxes = axisList.filter(({ attribute }) => attribute !== currentAxisId);

  const productsByAxisValue = products
    .filter(({ axesValues }) => axesValues.some(({ id }) => id === currentAxisId))
    .reduce((result, product) => {
      const { axesValues, productId } = product;
      const currentAxisValue = getAxisValue(currentAxisId, axesValues);
      const areOtherAxesValueMatched =
        axisList.length > 1
          ? otherAxes.every(
              ({ attribute }) =>
                getAxisValue(attribute, axesValues) === getAxisValue(attribute, activePoint.axesValues),
            )
          : true;

      if (
        !result.has(currentAxisValue) ||
        ((activePoint.productId === productId || areOtherAxesValueMatched) && result.has(currentAxisValue))
      ) {
        result.set(currentAxisValue, {
          isPuncturedPoint: !areOtherAxesValueMatched,
          label: currentAxisValue,
          axis: axisMeta.name,
          toProductUrl: product.productLink,
          mainPhoto: product.mediaMainPhoto,
          displayedName: product.displayedName,
          productPrice: product.productPrice,
          productId: product.productId,
          productBelong: product.productBelong,
        });
      }

      return result;
    }, new Map<string, ViewsModels.VariantAxisPoint>());

  return Array.from(productsByAxisValue.values());
};
